import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  description3PAOnly:
    'For all third-party accounts, funds are settled the following business day, with availability determined by the external account provider.',
})
